export default __webpack_public_path__ + "bca240f02a2754cc5215f55831bd75e5.png";